import { Component } from '@angular/core';
import { SwFormBuilderModule, FormElementMenuComponent, MainCanvasComponent, FieldSettingsComponent } from 'sw-form-builder';

@Component({
  selector: 'app-index',
  imports: [],
  templateUrl: './index.component.html',
  styleUrl: './index.component.scss'
})
export class IndexComponent {

}
